<template>
  <div>
    <UserIdleCheck/>
    <AboutBar/>
  </div>
</template>
<script>
import UserIdleCheck from "@/frame/control/components/UserIdleCheck";
import AboutBar from "@/frame/navigation/components/AboutBar";
export default {
  components: {
    AboutBar,
    UserIdleCheck
  }
};
</script>
